import {resources} from "../../../../../../../core/models/resource/resources";
import {ColumnPropertyLazySelect} from "../../../../../../../core/types/records-table.types";
import {LoadSelectDataParams} from "../types/create-quality-control.types";

export const qualityControlResourceType = resources['product-card-quality-controls'];

export const propertyLazySelectArticleWildberries: ColumnPropertyLazySelect = {
  recourseName: 'ProductCardQualityControl',
  providerType: 'QUALITY_CONTROL_WILDBERRIES_ARTICLES'
}

export const propertyLazySelectArticleOzon: ColumnPropertyLazySelect = {
  recourseName: 'ProductCardQualityControl',
  providerType: 'QUALITY_CONTROL_OZON_ARTICLES'
}


export const needLoadSelectDataByField: Array<LoadSelectDataParams> = [
  {
    key: 'nmId',
    propertyLazySelect: propertyLazySelectArticleWildberries
  },
  {
    key: 'sku',
    propertyLazySelect:propertyLazySelectArticleOzon
  }
]
